import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Search,
    Bell,
    CircleHelp,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    Calendar,
    Building2,
    CheckCircle2,
    AlertTriangle,
    MoreVertical,
    Download,
    Check,
} from "lucide-react";

import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import classes from "./BankTransactions.module.css";
import AddBankAccountModal from './AddBankAccountModal';

const transactions = [
    {
        reference: "TRF/20260814/927362",
        date: "14-08-26",
        narration: "TRANSFER TO XYZ LTD",
        debit: "0.00",
        cash: "500,000.00",
        balance: "1,250,000.00",
        status: "Unmatched",
        time: "14 Aug 2026, 10:24 AM",
        bank: "Access Bank",
    },
    {
        reference: "DEP/2026/0814/99123",
        date: "14-08-26",
        narration: "CASH DEPOSIT",
        debit: "0.00",
        cash: "200,000.00",
        balance: "1,450,000.00",
        status: "Matched",
        time: "14 Aug 2026, 09:42 AM",
        bank: "Access Bank",
    },
    {
        reference: "DEP/2026/0814/99123",
        date: "14-08-26",
        narration: "CASH DEPOSIT",
        debit: "0.00",
        cash: "200,000.00",
        balance: "1,450,000.00",
        status: "Unmatched",
        time: "14 Aug 2026, 09:15 AM",
        bank: "Access Bank",
    },
    {
        reference: "DEP/2026/0814/99123",
        date: "14-08-26",
        narration: "CASH DEPOSIT",
        debit: "0.00",
        cash: "200,000.00",
        balance: "1,450,000.00",
        status: "Matched",
        time: "14 Aug 2026, 08:55 AM",
        bank: "Access Bank",
    },
    {
        reference: "DEP/2026/0814/99123",
        date: "14-08-26",
        narration: "CASH DEPOSIT",
        debit: "0.00",
        cash: "200,000.00",
        balance: "1,450,000.00",
        status: "Unmatched",
        time: "14 Aug 2026, 08:30 AM",
        bank: "Access Bank",
    },
    {
        reference: "DEP/2026/0814/99123",
        date: "14-08-26",
        narration: "CASH DEPOSIT",
        debit: "0.00",
        cash: "200,000.00",
        balance: "1,450,000.00",
        status: "Matched",
        time: "14 Aug 2026, 08:10 AM",
        bank: "Access Bank",
    },
    {
        reference: "DEP/2026/0814/99123",
        date: "14-08-26",
        narration: "CASH DEPOSIT",
        debit: "0.00",
        cash: "200,000.00",
        balance: "1,450,000.00",
        status: "Unmatched",
        time: "14 Aug 2026, 07:52 AM",
        bank: "Access Bank",
    },
    {
        reference: "INT/2026/0811/00011",
        date: "11-08-26",
        narration: "INTEREST EARNED",
        debit: "0.00",
        cash: "35,000.00",
        balance: "1,090,000.00",
        status: "Matched",
        time: "11 Aug 2026, 03:20 PM",
        bank: "Access Bank",
    },
    {
        reference: "BIL/2026/0810/77822",
        date: "10-08-26",
        narration: "UTILITY PAYMENT",
        debit: "80,000.00",
        cash: "0.00",
        balance: "1,010,000.00",
        status: "Matched",
        time: "10 Aug 2026, 02:11 PM",
        bank: "Access Bank",
    },
    {
        reference: "TRF/2026/0810/66321",
        date: "10-08-26",
        narration: "TRANSFER FROM GHL LTD",
        debit: "0.00",
        cash: "720,000.00",
        balance: "1,730,000.00",
        status: "Unmatched",
        time: "10 Aug 2026, 11:06 AM",
        bank: "Access Bank",
    },
];

const BankTransactions = () => {
    const navigate = useNavigate();
    const [selectedTransaction, setSelectedTransaction] = useState(
        transactions[0]
    );

    const [search, setSearch] = useState("");

    const filteredTransactions = transactions.filter((transaction) =>
        `${transaction.reference} ${transaction.narration}`
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    const handleImportClick = () => {
        navigate("/ImportTransaction1");
    };
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className={classes.page}>
            <Header />
            <Sidebar />

            <main className={classes.main}>
                <div className={classes.container}>

                    {/* PAGE HEADER */}
                    <div className={classes.pageHeader}>
                        <div>
                            <h1>Bank Transactions</h1>

                            <p>
                                View and manage bank transactions for reconciliation
                            </p>
                        </div>
                        <div className={classes.btnstyle}>
                            <button
                                className={classes.downloadBtn}
                                onClick={handleImportClick}
                            >
                                <span><Download size={16} /></span>
                                Import Transactions
                            </button>
                            <button
                                className={classes.importButton}
                                onClick={() => setIsModalOpen(true)}
                            >
                                <span>+</span>
                                Add Bank Account
                            </button>

                            <AddBankAccountModal
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                            />
                        </div>
                    </div>

                    {/* STATISTICS */}
                    <div className={classes.statsGrid}>

                        <div className={classes.statCard}>
                            <div className={classes.statIcon}>
                                <Building2 size={19} />
                            </div>

                            <div>
                                <span>Total Transactions</span>
                                <strong>18,420</strong>
                                <small>This Month</small>
                            </div>
                        </div>

                        <div className={classes.statCard}>
                            <div className={classes.statIcon}>
                                <CheckCircle2 size={19} />
                            </div>

                            <div>
                                <span>Posted Credits</span>
                                <strong>9,260</strong>
                                <small>50.3%</small>
                            </div>
                        </div>

                        <div className={classes.statCard}>
                            <div className={classes.statIcon}>
                                <CheckCircle2 size={19} />
                            </div>

                            <div>
                                <span>Posted Debits</span>
                                <strong>8,210</strong>
                                <small>49.7%</small>
                            </div>
                        </div>

                        <div className={classes.statCard}>
                            <div className={classes.statIcon}>
                                <AlertTriangle size={19} />
                            </div>

                            <div>
                                <span>Unmatched</span>
                                <strong>342</strong>
                                <small>1.86%</small>
                            </div>
                        </div>

                    </div>

                    {/* FILTER BAR */}
                    <div className={classes.filterCard}>

                        <div className={classes.filterGroup}>
                            <label>Accounts</label>

                            <button>
                                All Accounts
                                <ChevronDown size={16} />
                            </button>
                        </div>

                        <div className={classes.filterGroup}>
                            <label>Banks</label>

                            <button>
                                All Banks
                                <ChevronDown size={16} />
                            </button>
                        </div>

                        <div className={classes.filterGroup}>
                            <label>Type</label>

                            <button>
                                All Types
                                <ChevronDown size={16} />
                            </button>
                        </div>

                        <div className={classes.filterGroup}>
                            <label>Currency</label>

                            <button>
                                All Status
                                <ChevronDown size={16} />
                            </button>
                        </div>

                        <div className={classes.filterGroupDate}>
                            <label>Date Range</label>

                            <button>
                                <Calendar size={16} />
                                <span>01 Aug 2026 - 14 Aug 2026</span>
                            </button>
                        </div>

                        <button className={classes.searchButton}>
                            Search
                        </button>

                        <button className={classes.cancelButton}>
                            Cancel
                        </button>

                    </div>

                    {/* TABLE + DETAILS */}
                    <div className={classes.contentArea}>

                        {/* TABLE */}
                        <div className={classes.tableCard}>

                            <div className={classes.tableHeader}>
                                <span>Reference / Date</span>
                                <span>Narration</span>
                                <span>Debit (₦)</span>
                                <span>Cash (₦)</span>
                                <span>Balance (₦)</span>
                                <span>Status</span>
                                <span>Actions</span>
                            </div>

                            <div className={classes.tableBody}>

                                {filteredTransactions.map((transaction, index) => (

                                    <div
                                        className={`${classes.tableRow} ${selectedTransaction.reference ===
                                            transaction.reference &&
                                            selectedTransaction.time ===
                                            transaction.time
                                            ? classes.selectedRow
                                            : ""
                                            }`}
                                        key={`${transaction.reference}-${index}`}
                                        onClick={() =>
                                            setSelectedTransaction(transaction)
                                        }
                                    >

                                        <div className={classes.reference}>
                                            <strong>
                                                {transaction.reference}
                                            </strong>

                                            <span>
                                                {transaction.date}
                                            </span>
                                        </div>

                                        <div className={classes.narration}>
                                            {transaction.narration}
                                        </div>

                                        <div>{transaction.debit}</div>

                                        <div>{transaction.cash}</div>

                                        <div>{transaction.balance}</div>

                                        <div>
                                            <span
                                                className={
                                                    transaction.status === "Matched"
                                                        ? classes.matched
                                                        : classes.unmatched
                                                }
                                            >
                                                {transaction.status}
                                            </span>
                                        </div>

                                        <button
                                            className={classes.moreButton}
                                            onClick={(e) =>
                                                e.stopPropagation()
                                            }
                                        >
                                            <MoreVertical size={17} />
                                        </button>

                                    </div>
                                ))}

                            </div>

                            {/* PAGINATION */}
                            <div className={classes.pagination}>

                                <span>
                                    Showing 1 to 10 of 18,420 transactions
                                </span>

                                <div className={classes.pages}>

                                    <button>
                                        <ChevronLeft size={15} />
                                    </button>

                                    <button className={classes.activePage}>
                                        1
                                    </button>

                                    <button>2</button>
                                    <button>3</button>
                                    <button>4</button>
                                    <button>5</button>

                                    <span>...</span>

                                    <button>1842</button>

                                    <button>
                                        <ChevronRight size={15} />
                                    </button>

                                    <button className={classes.pageSize}>
                                        10 / Page
                                        <ChevronDown size={14} />
                                    </button>

                                </div>

                            </div>

                        </div>

                        {/* DETAILS */}
                        <aside className={classes.detailsCard}>

                            <h2>Transaction Details</h2>

                            <span className={classes.detailStatus}>
                                {selectedTransaction.status}
                            </span>

                            <div className={classes.detailsList}>

                                <Detail
                                    label="Date & Time"
                                    value={selectedTransaction.time}
                                />

                                <Detail
                                    label="Reference"
                                    value={selectedTransaction.reference}
                                />

                                <Detail
                                    label="Narration"
                                    value={selectedTransaction.narration}
                                />

                                <Detail
                                    label="Debit Amount"
                                    value={`₦${selectedTransaction.debit}`}
                                />

                                <Detail
                                    label="Credit Amount"
                                    value={`₦${selectedTransaction.cash}`}
                                />

                                <Detail
                                    label="Balance"
                                    value={`₦${selectedTransaction.balance}`}
                                />

                                <Detail
                                    label="Bank"
                                    value={selectedTransaction.bank}
                                />

                                <div className={classes.detailDivider}></div>

                                <Detail
                                    label="Run"
                                    value="Aug 2026 - Run 14"
                                />

                                <Detail
                                    label="Rule Applied"
                                    value="Transfer Match"
                                />

                                <Detail
                                    label="Match Status"
                                    value={selectedTransaction.status}
                                    highlight
                                />

                            </div>

                            <div className={classes.detailButtons}>

                                <button className={classes.markButton}>
                                    <Check size={16} />
                                    Mark as Matched
                                </button>

                                <button className={classes.ledgerButton}>
                                    View Ledger
                                </button>

                            </div>

                        </aside>

                    </div>

                </div>
            </main>
        </div>
    );
};

const Detail = ({ label, value, highlight }) => (
    <div className={classes.detailRow}>
        <span>{label}</span>

        <strong
            className={highlight ? classes.highlightValue : ""}
        >
            {value}
        </strong>
    </div>
);

export default BankTransactions;